import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { CartCalculationSummaryModel, MinimumOrderValueModel } from '@libs/shop/models';
import { MatCard, MatCardContent } from '@angular/material/card';
import { OrderOverviewDetailsComponent } from './order-overview-details';

@Component({
  selector: 'ui-order-overview',
  templateUrl: './order-overview.component.html',
  styleUrls: ['./order-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    OrderOverviewDetailsComponent,
    MatCardContent,
    MatCard,
  ],
})
export class OrderOverviewComponent {
  public data: InputSignal<CartCalculationSummaryModel> = input.required();
  public minimumOrderValue: InputSignal<MinimumOrderValueModel | undefined> = input();
}
